export enum FooterVariables {
  Dealers = ':DEALERS:',
  Contacts = ':CONTACTS:',
  Phone = ':PHONE:',
  Call = ':CALL:',
}
